import { Button } from "antd";
import { store } from "services/store";
import { showModal } from "services/store/reducers/modalReducer";
import { StationsCompletionModal } from "shared/components/modals";
import { TableLECompletionReportVrUser, TableReportVrUser } from "shared/types";

export const VR_USER_COLUMNS = [
    {
        title: 'First name',
        key: 'FirstName',
        ellipsis: true,
        sortKey: 'FirstName',
        sorter: true,
        fixed: 'left' as const,
        width: 105,
        render: (user: TableReportVrUser): JSX.Element => (
            <span data-label='First Name'>{user.FirstName}</span>
        )
    },
    {
        title: 'Last name',
        key: 'LastName',
        ellipsis: true,
        sortKey: 'LastName',
        sorter: true,
        fixed: 'left' as const,
        width: 105,
        render: (user: TableReportVrUser): JSX.Element => (
            <span data-label='Last Name'>{user.LastName}</span>
        )
    },
    {
        title: 'Email',
        key: 'Email',
        ellipsis: true,
        sortKey: 'Email',
        sorter: true,
        width: 220,
        render: (user: TableReportVrUser): JSX.Element => (
            <span data-label='User Email'>{user.Email}</span>
        )
    },
    // {
    //     title: 'CurioXR #',
    //     key: 'Code',
    //     sortKey: 'Code',
    //     ellipsis: true,
    //     sorter: {
    //         multiple: 1
    //     },
    //     width: 120,
    //     render: (user: TableReportVrUser): JSX.Element => (
    //         <span data-label='CurioXR Number'>{user.Code}</span>
    //     )
    // },
    {
        title: 'Last Active',
        key: 'LastActive',
        sortKey: 'LastActive',
        ellipsis: true,
        sorter: true,
        width: 170,
        render: (user: TableReportVrUser): JSX.Element => (
            <span data-label='Last Active'>{user.LastActive}</span>
        )
    },
    {
        title: 'School',
        key: 'OrganizationName',
        sortKey: 'OrganizationName',
        ellipsis: true,
        sorter: true,
        width: 200,
        render: (user: TableReportVrUser): JSX.Element => (
            <span data-label='School'>{user.OrganizationName}</span>
        )
    }
];

export const VR_USER_LE_COMPLETION_COLUMNS = [
    {
        title: 'First name',
        key: 'firstname',
        ellipsis: true,
        sortKey: 'firstname',
        sorter: true,
        fixed: 'left' as const,
        width: 105,
        render: (user: TableLECompletionReportVrUser): JSX.Element => (
            <span data-label='First Name'>{user.firstname}</span>
        )
    },
    {
        title: 'Last name',
        key: 'lastname',
        ellipsis: true,
        sortKey: 'lastname',
        sorter: true,
        fixed: 'left' as const,
        width: 105,
        render: (user: TableLECompletionReportVrUser): JSX.Element => (
            <span data-label='Last Name'>{user.lastname}</span>
        )
    },
    {
        title: 'Email',
        key: 'email',
        ellipsis: true,
        sortKey: 'email',
        sorter: true,
        width: 220,
        render: (user: TableLECompletionReportVrUser): JSX.Element => (
            <span data-label='User Email'>{user.email}</span>
        )
    },
    // {
    //     title: 'CurioXR #',
    //     key: 'curionumber',
    //     sortKey: 'curionumber',
    //     ellipsis: true,
    //     sorter: {
    //         multiple: 1
    //     },
    //     width: 120,
    //     render: (user: TableLECompletionReportVrUser): JSX.Element => (
    //         <span data-label='CurioXR Number'>{user.curionumber}</span>
    //     )
    // },
    {
        title: 'LEs Completed',
        key: 'lescompleted',
        sortKey: 'lescompleted',
        ellipsis: true,
        sorter: true,
        width: 170,
        render: (user: TableLECompletionReportVrUser): JSX.Element => (
            <span data-label='LEs Completed'>{user.lescompleted}</span>
        )
    },
    {
        title: 'LEs in Progress',
        key: 'lesinprogress',
        sortKey: 'lesinprogress',
        ellipsis: true,
        sorter: true,
        width: 170,
        render: (user: TableLECompletionReportVrUser): JSX.Element => {
            const value = user.lesinprogress;
            const hasStationData = !!user.leData && Object.keys(user.leData).length > 0;
            if (!hasStationData) {
                return <span data-label='LEs in Progress'>{value}</span>;
            }
            const openStations = (): void => {
                store.dispatch(showModal(<StationsCompletionModal user={user} />));
            };
            return (
                <Button
                    data-label='LEs in Progress'
                    type='link'
                    onClick={openStations}
                    style={{
                        padding: 0,
                        height: 'auto',
                        textAlign: 'left',
                        whiteSpace: 'normal',
                        color: '#1677ff',
                        opacity: 1,
                    }}
                >
                    {value || 'View stations'}
                </Button>
            );
        }
    },
];